export const errorByStatus = {
  500: 'Internal server error',
  400: 'Terjadi kesalahan, Data tidak diterima',
  401: 'Unauthorized'
}